import Vue from 'vue'
import Vuex from 'vuex'
// 三个模块
import app from './app/'
import sideNav from './side-nav/'
import user from './user/'
import mixed from './mixed'
import quiz from './quiz'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  modules: {
    app,
    sideNav,
    user,
    mixed,
    quiz
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js